import { useCallback, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Module } from '../../../../../../api/module';
import { useFilterInLocalStorage } from '../../../components/per-student/hooks/useFilterInLocalStorage';
import { FilterSearchParam } from '../../../../../../shared-components/elementis/types/FilterSearchParam';
import { useResultsDataContext } from '../../ResultsDataContext';

export function useSelectedModule() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { modules } = useResultsDataContext();
  const { getStoredData } = useFilterInLocalStorage(modules[0]?.id);

  const selectedModuleId = searchParams.get(FilterSearchParam.Module);

  const selectedModule: Module | null = useMemo(() => {
    if (selectedModuleId) {
      return modules.find(m => m.id === selectedModuleId) || null;
    }

    return null;
  }, [modules, selectedModuleId]);

  const setSelectedModule = useCallback(
    (module: Module) => {
      setSearchParams(prev => {
        const newParams = new URLSearchParams(prev);
        newParams.set('module', module.id);
        return newParams;
      });
    },
    [setSearchParams],
  );

  useEffect(() => {
    if (selectedModuleId) return;

    const filterConfig = getStoredData();
    if (filterConfig === null) return;

    const module = modules.find(m => m.id === filterConfig.moduleId);
    if (module) setSelectedModule(module);
  }, [getStoredData, modules, selectedModuleId, setSearchParams, setSelectedModule]);

  return [selectedModule, setSelectedModule] as const;
}
